var React = require('react');

function IconFx (props) {
    return React.createElement("svg",props,[React.createElement("g",{"clipPath":"url(#clip0_4_1218)","key":0},[React.createElement("path",{"d":"M25.496 0H0.636993V18.644H25.496V0Z","fill":"#325990","key":0}),React.createElement("path",{"d":"M3.487 2.86902V16.102H6.735V10.934H11.137V8.03702H6.735V5.74302H12.162L10.482 2.86902H3.487Z","fill":"white","key":1}),React.createElement("path",{"d":"M23.456 16.102H19.704L15.656 9.48502L19.553 2.86902H23.456L19.553 9.48502L23.456 16.102Z","fill":"#BDCFDC","key":2}),React.createElement("path",{"d":"M11.754 2.86902H15.501L19.553 9.48502L15.656 16.102H11.754L15.656 9.48502L11.754 2.86902Z","fill":"white","key":3})]),React.createElement("defs",{"key":1},React.createElement("clipPath",{"id":"clip0_4_1218"},React.createElement("rect",{"width":"26","height":"19","fill":"white"})))]);
}

IconFx.defaultProps = {"width":"26","height":"19","viewBox":"0 0 26 19","fill":"none"};

module.exports = IconFx;

IconFx.default = IconFx;
